import { profile } from "api";
import { useContextProfile } from "context";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const tooltipId = "#Tooltip";

const steps = [
    {
        targetId: "#add-cases-btn",
        title: "Add Cases",
        subTitle: "Tap here to search for cases to add to your list.",
    }
];

export const useTooltip = (initStep: number) => {
    const {userData, setUserData} = useContextProfile();
    const location = useLocation();
    const [step, setStep] = useState(initStep || 0);
    const [show, setIsShow] = useState<boolean>(false);

    const [title, setTitle] = useState<string>("");
    const [subTitle, setSubTitle] = useState<string>("");

    const getLocation = (targetId: string) => {
        if (!window.document) return;
        let targetEl = window.document.querySelector(targetId);
        let tooltipEl: HTMLElement|null = window.document.querySelector(tooltipId);
        if (!targetEl || !tooltipEl) return; 
        
        let target = targetEl.getBoundingClientRect();
        let tooltip = tooltipEl.getBoundingClientRect();

        let x = target.x + (.5 * target.width) - tooltip.width + 40;
        let y = target.y + target.height + 12;

        tooltipEl.style.opacity = '1';
        tooltipEl.style.left = x + 'px';
        tooltipEl.style.top = y + 'px';
    }

    useEffect(() => {
        if (!userData || userData.type !== 'user' || location.pathname !== '/cases') return;
        const showedOnboarding = userData?.is_onboarded_tooltip ? false : true;
        setTimeout(() => { 
            const foundElement = window.document.querySelector(steps[step].targetId) ? true : false;
            setIsShow(showedOnboarding && foundElement);
        }, 500);
    }, [userData, location]);

    useEffect(() => {
        const data = steps[step];
        setTitle(data.title);
        setSubTitle(data.subTitle);
        setTimeout(() => { 
            getLocation(data.targetId);
        }, 500);
    }, [step, show]);

    const onNext = async () => {
        if (!steps[step + 1]) {
            setIsShow(false);
            await profile
                .updateProfile({is_onboarded_tooltip: true})
                .then(({data: {data}}) => setUserData(data));
            return;
        }
        setStep(step + 1);
    }

    return {
        show, setIsShow,
        title,
        subTitle,
        onNext
    }
}